import { Serializable } from '../../../core/models/serializable';
export class AnnouncementsTotalPerCustomerListItemGroupModel
  implements Serializable<AnnouncementsTotalPerCustomerListItemGroupModel>
{
  fromObject(obj: any): AnnouncementsTotalPerCustomerListItemGroupModel {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public amount: number;
  public date: Date;
}
